import moment from "moment-timezone";

/**
 * get weekly schedule / interval by timezone
 * split interval if needed
 */
export default function getWeeklyIntervals(
  availableIntervals: ScheduleInterval[],
  timezone: TimeZone,
): WeeklyAvailableIntervals {
  const templates = Array(7).fill(null);

  availableIntervals.forEach((el) => {
    const startDayIndex = moment(el.start_time).tz(timezone).weekday();
    const endDayIndex = moment(el.end_time).tz(timezone).weekday();

    const splitTimeValue = moment(el.end_time)
      .tz(timezone)
      .startOf("day")
      .valueOf();

    const splitTime = moment(el.end_time)
      .tz(timezone)
      .startOf("day")
      .toISOString();

    // if same day or end of the prev day and start of the next day
    if (
      startDayIndex === endDayIndex ||
      splitTimeValue === +new Date(el.end_time)
    ) {
      if (!templates[startDayIndex]) {
        return (templates[startDayIndex] = [el]);
      }
      return templates[startDayIndex].push(el);
    }

    if (!templates[startDayIndex]) {
      templates[startDayIndex] = [];
    }
    if (!templates[endDayIndex]) {
      templates[endDayIndex] = [];
    }
    // solve inconsistencies of native date api and moment api
    if (+new Date(splitTime) !== +new Date(el.end_time)) {
      // start of day
      templates[endDayIndex].unshift({
        start_time: splitTime,
        end_time: el.end_time,
      });
    }
    if (+new Date(splitTime) !== +new Date(el.start_time)) {
      templates[startDayIndex].push({
        start_time: el.start_time,
        end_time: splitTime,
      });
    }
  });

  return templates;
}
